/**
 * Coure.Hub.Service.Plan
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllServicePlanResponseDto } from '../model/allServicePlanResponseDto';
import { CreatePlanRequestDto } from '../model/createPlanRequestDto';
import { GenericResponseDto } from '../model/genericResponseDto';
import { PlanSetUpRequestDto } from '../model/planSetUpRequestDto';
import { PlanSetupTblGenericResponse } from '../model/planSetupTblGenericResponse';
import { ServicePlanResponseDto } from '../model/servicePlanResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServicePlanService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanCreateServicePlanPost(body?: CreatePlanRequestDto, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDto>;
    public apiServicePlanCreateServicePlanPost(body?: CreatePlanRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDto>>;
    public apiServicePlanCreateServicePlanPost(body?: CreatePlanRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDto>>;
    public apiServicePlanCreateServicePlanPost(body?: CreatePlanRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GenericResponseDto>('post',`${this.basePath}/api/ServicePlan/CreateServicePlan`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param planId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanDeleteServicePlanPlanIdDelete(planId: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDto>;
    public apiServicePlanDeleteServicePlanPlanIdDelete(planId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDto>>;
    public apiServicePlanDeleteServicePlanPlanIdDelete(planId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDto>>;
    public apiServicePlanDeleteServicePlanPlanIdDelete(planId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling apiServicePlanDeleteServicePlanPlanIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDto>('delete',`${this.basePath}/api/ServicePlan/DeleteServicePlan/${encodeURIComponent(String(planId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanGetAllServicePlanGet(observe?: 'body', reportProgress?: boolean): Observable<AllServicePlanResponseDto>;
    public apiServicePlanGetAllServicePlanGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllServicePlanResponseDto>>;
    public apiServicePlanGetAllServicePlanGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllServicePlanResponseDto>>;
    public apiServicePlanGetAllServicePlanGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllServicePlanResponseDto>('get',`${this.basePath}/api/ServicePlan/GetAllServicePlan`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanGetServicePlanbyIdIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<ServicePlanResponseDto>;
    public apiServicePlanGetServicePlanbyIdIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServicePlanResponseDto>>;
    public apiServicePlanGetServicePlanbyIdIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServicePlanResponseDto>>;
    public apiServicePlanGetServicePlanbyIdIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiServicePlanGetServicePlanbyIdIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServicePlanResponseDto>('get',`${this.basePath}/api/ServicePlan/GetServicePlanbyId/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanGetServicePlanbySPIdSpIdGet(spId: string, observe?: 'body', reportProgress?: boolean): Observable<AllServicePlanResponseDto>;
    public apiServicePlanGetServicePlanbySPIdSpIdGet(spId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllServicePlanResponseDto>>;
    public apiServicePlanGetServicePlanbySPIdSpIdGet(spId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllServicePlanResponseDto>>;
    public apiServicePlanGetServicePlanbySPIdSpIdGet(spId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (spId === null || spId === undefined) {
            throw new Error('Required parameter spId was null or undefined when calling apiServicePlanGetServicePlanbySPIdSpIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllServicePlanResponseDto>('get',`${this.basePath}/api/ServicePlan/GetServicePlanbySPId/${encodeURIComponent(String(spId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceproviderId 
     * @param servicePlanId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanGetsetupforserviceplanGet(serviceproviderId?: string, servicePlanId?: string, observe?: 'body', reportProgress?: boolean): Observable<PlanSetupTblGenericResponse>;
    public apiServicePlanGetsetupforserviceplanGet(serviceproviderId?: string, servicePlanId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PlanSetupTblGenericResponse>>;
    public apiServicePlanGetsetupforserviceplanGet(serviceproviderId?: string, servicePlanId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PlanSetupTblGenericResponse>>;
    public apiServicePlanGetsetupforserviceplanGet(serviceproviderId?: string, servicePlanId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceproviderId !== undefined && serviceproviderId !== null) {
            queryParameters = queryParameters.set('serviceproviderId', <any>serviceproviderId);
        }
        if (servicePlanId !== undefined && servicePlanId !== null) {
            queryParameters = queryParameters.set('servicePlanId', <any>servicePlanId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PlanSetupTblGenericResponse>('get',`${this.basePath}/api/ServicePlan/getsetupforserviceplan`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServicePlanSetUpServicePlanPost(body?: PlanSetUpRequestDto, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDto>;
    public apiServicePlanSetUpServicePlanPost(body?: PlanSetUpRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDto>>;
    public apiServicePlanSetUpServicePlanPost(body?: PlanSetUpRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDto>>;
    public apiServicePlanSetUpServicePlanPost(body?: PlanSetUpRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GenericResponseDto>('post',`${this.basePath}/api/ServicePlan/SetUpServicePlan`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
